<template>
    <div>
        <b-table
            id="cdas"
            :items="resultado"
            :fields="fields"
            striped
            small
            responsive="sm"
            tbody-tr-class="rowClass"
            :no-local-sorting="true"
            @sort-changed="sortingChanged"
            :busy="configTable.load"
            show-empty
            >
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>
            <template slot="empty">
                <p class="my-auto">Não existem cartas emitidas sem assinatura.</p>
            </template>
            <template slot="HEAD_selecionar">
                <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
            </template>
            <template slot="selecionar" slot-scope="row">
                <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="row.item.checked" @change="toggleCheck($event, row.item)" />
            </template>
            <template slot="1" slot-scope="row">
                <b-link @click="abrirModalExtratoCda(row.item.codCdaSefa)" class="m-0 p-0 text-center">
                    <p class="m-0 p-0">{{row.item.numeroDivida}}</p>
                </b-link>
            </template>
            <template slot="2" slot-scope="row">
                {{ row.item.dataCarta }}
            </template>
            <template slot="3" slot-scope="row">
                {{ row.item.tipoCarta.nome }}
            </template>
            <template slot="4" slot-scope="row">
                {{ row.item.motivo }}
            </template>
            <template slot="5" slot-scope="row">
                {{ row.item.tipoCredito }}
            </template>
            <template slot="6" slot-scope="row">
                {{ row.item.origem }}
            </template>
            <template slot="7" slot-scope="row">
                {{ row.item.tabelionato}}
            </template>
            <template slot="8" slot-scope="row">
                {{ row.item.protocolot32}}
            </template>
            <template slot="9" slot-scope="row">
                {{ row.item.usuario }}
            </template>
            <template slot="10" slot-scope="row">
                <p class="m-0 p-0 text-left">
                    {{ row.item.contribuinte }}
                    <template v-for="c in row.item.outrosContribuintes">
                        <br :key="c.contribuinte" />
                        {{ c.contribuinte }}
                    </template>
                </p>
            </template>
        </b-table>

        <ExtratoCda
            ref="extratoCda"
            @closeModal="closeModal" />
    </div>
</template>

<script>
import ExtratoCda from "../../shared/components/ExtratoCda";
export default {
    components: {ExtratoCda},
    props: ['resultado', 'fields', 'configTable', 'selecteds'],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false
            this.$emit('consultarCartas')
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el)) {
                        this.selecteds.push(el)
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el)) {
                        const index = this.selecteds.indexOf(el)
                        this.selecteds.splice(index, 1)
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked
                this.selecteds.push(item)
            } else {
                item.checked = checked
                const index = this.selecteds.indexOf(item)
                this.selecteds.splice(index, 1)
            }
        },
        sortingChanged(ctx) {
            if(ctx.sortBy == 1) {
                this.configTable.sortField = 'numeroDivida'
            }
            if(ctx.sortBy == 2) {
                this.configTable.sortField = 'dataCarta'
            }
            if(ctx.sortBy == 3) {
                this.configTable.sortField = 'tipoCarta'
            }
            if(ctx.sortBy == 4) {
                this.configTable.sortField = 'motivo'
            }
            if(ctx.sortBy == 5) {
                this.configTable.sortField = 'tipoCredito'
            }
            if(ctx.sortBy == 6) {
                this.configTable.sortField = 'origem'
            }
            if(ctx.sortBy == 7) {
                this.configTable.sortField = 'tabelionato'
            }
            if(ctx.sortBy == 8) {
                this.configTable.sortField = 'protocolot32'
            }
            if(ctx.sortBy == 9) {
                this.configTable.sortField = 'usuario'
            }
            if(ctx.sortBy == 10) {
                this.configTable.sortField = 'devedor'
            }
            this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.$emit('sortingChanged')
        },
        abrirModalExtratoCda(codCdaSefa) {
            this.$refs['extratoCda'].abrirExtrato(codCdaSefa);
        },
        closeModal() {
            this.$refs['extratoCda'].fecharModais();
        },
    }

}
</script>

<style scoped>
.no-line {
    white-space: nowrap;
}
</style>
